import { SP_MSAL_SCOPE } from '../constants/sharepoint';

export const msalConfig = {
  auth: {
    // clientId: "e68013c6-b6fe-4798-8288-750c2606d5ec", // Dev
    clientId: "4857055b-ead8-4b42-8b4b-216034dc6c29", // UAT/PROD
    // authority: "https://login.microsoftonline.com/8efa5ce2-86e4-4882-840c-f2578cdf094c", // Dev
    authority: "https://login.microsoftonline.com/aa44c5c1-5448-4e74-88d9-17838a6f9d5a", // UAT/PROD
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [SP_MSAL_SCOPE],
};
